module.exports = __webpack_public_path__ + "static/media/HM-Full-White-v3.aff772cd.png";